import React, { createContext, useState, useEffect } from 'react';
import BrandService from 'services/ProductsService/brand.service';

interface DataProviderProps {
  children: React.ReactNode;
}
interface Supplier {
  id:number;
  name: string;
  company_id: number;
  address: {
    address_name: string;
    street: string;
    city: string;
    province: string;
    country: string;
    postal_code: string;
  };
}
interface DataProviderContextInterface {
  data: Supplier[];
  addData: (newData: Supplier) => void;
  deleteData: (id: number) => void;
  searchValue: string;
  handleSearchValue: (value: string) => void;
  updateData: (id: number, newData: Supplier) => void;
}

export const DataListContext = createContext<DataProviderContextInterface>({
  data: [],
  addData: () => {},
  deleteData: () => {},
  searchValue: '',
  handleSearchValue: () => {},
  updateData: () => {},
});

export const DataProvider = ({ children }: DataProviderProps) => {
  const { fetchBrands } = BrandService();
  const [data, setData] = useState<Supplier[]>([]);
  const [searchValue, setSearchValue] = useState<string>('');
  useEffect(() => {
    fetchBrands({ name: searchValue });
  }, [searchValue]);

  const addData = (newSupplier: Supplier) => {
    setData(prevSuppliers => [...prevSuppliers, newSupplier]);
  };

  const updateData = (id: number, newSupplier: Supplier) => {
    setData(prevItems => {
      return prevItems.map(item => {
        if (item.id === id) {
          return newSupplier;
        }
        return item;
      });
    });
  };

  const deleteData = (id: number) => {
    setData(prevSuppliers =>
      prevSuppliers.filter(supplier => supplier.id !== id)
    );
  };
  const handleSearchValue = (value: string) => {
    setSearchValue(value);
  };
  return (
    <DataListContext.Provider
      value={{
        data,
        addData,
        deleteData,
        searchValue,
        handleSearchValue,
        updateData,
      }}>
      {children}
    </DataListContext.Provider>
  );
};
